import { createContext, Dispatch, useState } from "react";

export type ConfigurationSaveStatus = "draft" | "saved";

export const useConfigurationSaveStatusContext = (): [ConfigurationSaveStatus, Dispatch<ConfigurationSaveStatus>] =>
  useState<ConfigurationSaveStatus>("saved");

const ConfigurationSaveStatusDispatch = createContext<Dispatch<ConfigurationSaveStatus>>(() => {});

export default ConfigurationSaveStatusDispatch;
